/**
 * Campaign Meta Product — Vanilla JS
 * Handles: inclusion selector, ATC form, sticky ATC bar, accordions.
 * No jQuery. No third-party libraries.
 * Runs after DOM is ready (loaded via defer in theme.campaign.liquid).
 */

(function () {
  'use strict';

  // ─── Inclusion Selector ─────────────────────────────────────────────────
  // Updates the hidden line item property input when user selects a radio.
  // Manages selected card visual state.

  var inclusionRadios = document.querySelectorAll('[data-inclusion-radio]');
  var inclusionProperty = document.getElementById('campaign-inclusion-property');

  if (inclusionRadios.length && inclusionProperty) {
    inclusionRadios.forEach(function (radio) {
      radio.addEventListener('change', function () {
        // Update the hidden form property
        inclusionProperty.value = this.value;

        // Update visual selected state on cards
        document.querySelectorAll('.c-inclusion-card').forEach(function (card) {
          card.classList.remove('is-selected');
        });
        var parentCard = this.closest('.c-inclusion-card');
        if (parentCard) {
          parentCard.classList.add('is-selected');
        }
      });
    });
  }


  // ─── Upsell Cards → Bonus Reveal ────────────────────────────────────────
  // New: mirrors Smile's mechanism exactly. Selecting an upsell card marks it
  // active; the bonus block (if present) is dimmed/non-interactive by default
  // and only becomes clickable once at least one upsell card is selected —
  // see .c-upsell__bonus.is-visible rules in campaign-meta-product.css.
  // Re-clicking an upsell card toggles it off (and re-locks bonus if it was
  // the only one selected).

  var upsellCards = document.querySelectorAll('[data-upsell-card]');
  var upsellBonus = document.querySelector('[data-upsell-bonus]');

  function refreshBonusVisibility() {
    if (!upsellBonus) return;
    var anySelected = document.querySelector('[data-upsell-card].is-selected');
    upsellBonus.classList.toggle('is-visible', !!anySelected);
  }

  upsellCards.forEach(function (card) {
    var btn = card.querySelector('[data-upsell-add]');
    if (!btn) return;

    var variantSelect = card.querySelector('[data-upsell-variant-select]');
    if (variantSelect) {
      variantSelect.addEventListener('change', function () {
        card.setAttribute('data-upsell-variant', this.value);
        var selectedOption = this.options[this.selectedIndex];
        var newPrice = parseInt(selectedOption.getAttribute('data-price'), 10) || 0;
        card.setAttribute('data-upsell-price', newPrice);
      });
    }

    btn.addEventListener('click', function () {
      var wasSelected = card.classList.contains('is-selected');
      card.classList.toggle('is-selected', !wasSelected);
      btn.textContent = wasSelected
        ? (btn.getAttribute('data-upsell-default-label') || 'Add to Order')
        : 'Added ✓';
      refreshBonusVisibility();
    });
  });


  // ─── Bonus Product Selection ─────────────────────────────────────────────
  // New: tracks which bonus variant (if any) is selected, for inclusion in
  // the chained add-to-cart request below. Cards are non-interactive until
  // .c-upsell__bonus carries .is-visible (see refreshBonusVisibility above),
  // so this only has an effect once an upsell has been selected.

  var bonusRadios = document.querySelectorAll('[data-bonus-radio]');
  var selectedBonusVariantId = null;

  bonusRadios.forEach(function (radio) {
    radio.addEventListener('change', function () {
      document.querySelectorAll('.c-bonus-card').forEach(function (c) {
        c.classList.remove('is-selected');
      });
      var parentCard = this.closest('.c-bonus-card');
      if (parentCard) {
        parentCard.classList.add('is-selected');
        selectedBonusVariantId = parentCard.getAttribute('data-bonus-variant');
      }
    });

    if (radio.checked) {
      var checkedCard = radio.closest('.c-bonus-card');
      if (checkedCard) {
        checkedCard.classList.add('is-selected');
        selectedBonusVariantId = checkedCard.getAttribute('data-bonus-variant');
      }
    }
  });


  // ─── Add to Cart Form ───────────────────────────────────────────────────
  // Intercepts the product form submit, adds the main item, then chain-adds
  // any selected upsell item(s) and the selected bonus item (if unlocked and
  // chosen) as separate cart line items — same sequential-request pattern
  // Smile uses, so upsell/bonus items only ever get added alongside the main
  // product, never as standalone additions.

  var form = document.getElementById('campaign-product-form');
  var atcBtn = document.getElementById('campaign-atc-btn');

  function addToCartRequest(payload) {
    return fetch(window.routes.cartAddUrl + '.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Accept': 'application/json'
      },
      body: JSON.stringify(payload)
    }).then(function (response) {
      if (!response.ok) {
        return response.json().then(function (data) {
          throw new Error(data.description || 'Could not add to cart');
        });
      }
      return response.json();
    });
  }

  if (form && atcBtn) {
    form.addEventListener('submit', function (e) {
      e.preventDefault();

      // Guard: don't double-submit
      if (atcBtn.classList.contains('is-loading')) return;

      // Read current inclusion value (may have been updated by radio handler)
      var inclusionValue = inclusionProperty ? inclusionProperty.value : 'No Complimentary Inclusion';

      var variantId = form.querySelector('[name="id"]').value;
      if (!variantId) return;

      // Visual loading state
      atcBtn.classList.add('is-loading');
      var originalText = atcBtn.textContent;
      atcBtn.textContent = 'Adding…';

      var mainPayload = {
        id: parseInt(variantId, 10),
        quantity: 1,
        properties: {
          'Complimentary Inclusion': inclusionValue
        }
      };

      var selectedUpsellCards = Array.prototype.filter.call(
        upsellCards,
        function (c) { return c.classList.contains('is-selected'); }
      );

      var addChain = addToCartRequest(mainPayload);

      selectedUpsellCards.forEach(function (card) {
        var upsellVariantId = card.getAttribute('data-upsell-variant');
        if (!upsellVariantId) return;
        addChain = addChain.then(function () {
          return addToCartRequest({ id: parseInt(upsellVariantId, 10), quantity: 1 });
        });
      });

      if (selectedBonusVariantId && upsellBonus && upsellBonus.classList.contains('is-visible')) {
        addChain = addChain.then(function () {
          return addToCartRequest({ id: parseInt(selectedBonusVariantId, 10), quantity: 1 });
        });
      }

      addChain
      .then(function () {
        // Redirect to cart so customer can review inclusions, upsells, and shipping
        window.location.href = '/cart';
      })
      .catch(function (err) {
        atcBtn.classList.remove('is-loading');
        atcBtn.textContent = originalText;
        console.error('[Campaign ATC]', err.message);
        // Fallback: native form submit so the main item still gets added
        form.submit();
      });
    });
  }


  // ─── Sticky ATC Bar ─────────────────────────────────────────────────────
  // Mobile only. Shows the sticky bar once the hero ATC button scrolls out
  // of view. Tapping the sticky button triggers the hero form submit.

  var heroAtcBtn = document.getElementById('campaign-atc-btn');
  var stickyBar = document.getElementById('campaign-sticky-atc');
  var stickyBtn = document.getElementById('campaign-sticky-atc-btn');

  if (heroAtcBtn && stickyBar) {
    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            stickyBar.classList.remove('is-visible');
            stickyBar.setAttribute('aria-hidden', 'true');
          } else {
            stickyBar.classList.add('is-visible');
            stickyBar.setAttribute('aria-hidden', 'false');
          }
        });
      },
      {
        threshold: 0,
        rootMargin: '0px 0px 0px 0px'
      }
    );

    observer.observe(heroAtcBtn);
  }

  if (stickyBtn && form) {
    stickyBtn.addEventListener('click', function () {
      // Trigger the hero form's submit event — same handler runs,
      // so inclusion property is included correctly.
      form.dispatchEvent(new Event('submit', { bubbles: true, cancelable: true }));
    });
  }


  // ─── Accordion ──────────────────────────────────────────────────────────
  // Plain JS accordion. Trigger button toggles aria-expanded.
  // Body height animates via max-height transition in CSS.

  var accordions = document.querySelectorAll('[data-accordion]');

  accordions.forEach(function (accordion) {
    var trigger = accordion.querySelector('.c-accordion__trigger');
    var body = accordion.querySelector('.c-accordion__body');

    if (!trigger || !body) return;

    trigger.addEventListener('click', function () {
      var isOpen = trigger.getAttribute('aria-expanded') === 'true';

      if (isOpen) {
        trigger.setAttribute('aria-expanded', 'false');
        body.style.maxHeight = '0';
      } else {
        trigger.setAttribute('aria-expanded', 'true');
        body.style.maxHeight = body.scrollHeight + 'px';
      }
    });
  });


  // ─── Cart Count Update ──────────────────────────────────────────────────
  // Fetches the current cart item count and updates the header badge.

  function updateCartCount() {
    fetch('/cart.js', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badges = document.querySelectorAll('[data-cart-count]');
      badges.forEach(function (badge) {
        badge.textContent = cart.item_count;
        if (cart.item_count > 0) {
          badge.classList.remove('c-site-header__cart-count--empty');
        } else {
          badge.classList.add('c-site-header__cart-count--empty');
        }
      });
    })
    .catch(function () {
      // Non-fatal — count will refresh on next page load
    });
  }


  // ─── Upsell Info Popup ───────────────────────────────────────────────────
  // New: reuses Smile's popup open/close behaviour verbatim, renamed to
  // Campaign's campaign- element IDs. Shows per-upsell-item info content
  // (smile.popup_content) in a modal when the card's info "i" button is clicked.

  var popupOverlay = document.getElementById('campaign-popup-overlay');
  var popupClose = document.getElementById('campaign-popup-close');
  var popupTitle = document.getElementById('campaign-popup-title');
  var popupBody = document.getElementById('campaign-popup-body');

  function openPopup(title, content) {
    if (!popupOverlay || !popupTitle || !popupBody) return;
    popupTitle.textContent = title;
    popupBody.innerHTML = content;
    popupOverlay.classList.add('is-open');
    popupOverlay.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    if (popupClose) popupClose.focus();
  }

  function closePopup() {
    if (!popupOverlay) return;
    popupOverlay.classList.remove('is-open');
    popupOverlay.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }

  document.querySelectorAll('[data-popup-trigger]').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.stopPropagation();
      var title = this.getAttribute('data-popup-title') || '';
      var content = this.getAttribute('data-popup-content') || '';
      openPopup(title, content);
    });
  });

  if (popupClose) {
    popupClose.addEventListener('click', closePopup);
  }

  if (popupOverlay) {
    popupOverlay.addEventListener('click', function (e) {
      if (e.target === popupOverlay) closePopup();
    });
  }

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && popupOverlay && popupOverlay.classList.contains('is-open')) {
      closePopup();
    }
  });

})();
